import { Paper, Typography } from "@material-ui/core";
import React from "react";
import { timestampToDate } from "../../../../../../services/utils";

// 22 = "Edición de orden de compra" (ver tipoChangesJson en
// ParticipantDetail/ChangesDetail.jsx, y OrderDetail.jsx que escribe este
// código al guardar cambios en los ítems de una orden).
const ACTION_ORDEN_EDITADA = 22;

const celdaCompacta = { padding: "3px 10px" };

// Lista plana (una fila por cambio, no agrupada por atleta como
// ChangesList.jsx) de todas las ediciones de orden del evento — recorre
// changesRegistry de cada inscrito buscando action=22.
const OrderChangesList = ({ eventParticipants }) => {
  var filas = [];

  for (var i in eventParticipants) {
    var participante = eventParticipants[i];
    var changesRegistry = participante.changesRegistry;
    for (var ts in changesRegistry) {
      var cambio = changesRegistry[ts];
      if (cambio.action === ACTION_ORDEN_EDITADA) {
        filas.push({
          key: i + "_" + ts,
          folio: participante.numero != null ? participante.numero : "No Asignado",
          nombres: participante.nombres,
          apellidos: participante.apellidos,
          descripcion: cambio.description,
          usuario: `${cambio.nombresUser || ""} ${cambio.apellidosUser || ""}`,
          fecha: cambio.date,
        });
      }
    }
  }

  filas.sort((a, b) => b.fecha - a.fecha);

  return (
    <Paper style={{ margin: 5, padding: 20 }}>
      <Typography variant={"h3"} align="left">
        Lista de cambios en órdenes
      </Typography>

      <table className="striped">
        <thead>
          <tr>
            <th style={celdaCompacta}>Folio</th>
            <th style={celdaCompacta}>Nombres</th>
            <th style={celdaCompacta}>Apellidos</th>
            <th style={celdaCompacta}>Descripción del cambio</th>
            <th style={celdaCompacta}>Usuario</th>
            <th style={celdaCompacta}>Fecha</th>
          </tr>
        </thead>
        <tbody>
          {filas.map((f) => (
            <tr key={f.key}>
              <td style={celdaCompacta}>{f.folio}</td>
              <td style={celdaCompacta}>{f.nombres}</td>
              <td style={celdaCompacta}>{f.apellidos}</td>
              <td style={celdaCompacta}>{f.descripcion}</td>
              <td style={celdaCompacta}>{f.usuario}</td>
              <td style={celdaCompacta}>{timestampToDate(f.fecha)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Paper>
  );
};
export default OrderChangesList;
